import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { calculateChartFromChartData } from 'vio-libs';
import { calculateSiteChartsFromChartsDictionaryData } from '../../lib';
import { getOrganizationSlug } from '../organizations/selectors';
import { getAirflowChart, getEgressInterfaceChart, getEgressLockerCharts, getEgressSiteCharts, getHumidityChart, getIngressInterfaceChart, getIngressLockerCharts, getIngressSiteCharts, getPowerConsumptionChart, getPressureChart, getTemperatureChart } from './data';
import { errorReceiveAirflowChart, errorReceiveEgressInterfaceChart, errorReceiveEgressLockerCharts, errorReceiveEgressSiteCharts, errorReceiveHumidityChart, errorReceiveIngressInterfaceChart, errorReceiveIngressLockerCharts, errorReceiveIngressSiteCharts, errorReceiveLockerPowerConsumptionChart, errorReceivePowerConsumptionChart, errorReceivePressureChart, errorReceiveRackPressureChart, errorReceiveRackTemperatureChart, errorReceiveTemperatureChart, failedReceiveAirflowChart, failedReceiveEgressInterfaceChart, failedReceiveEgressLockerCharts, failedReceiveEgressSiteCharts, failedReceiveHumidityChart, failedReceiveIngressInterfaceChart, failedReceiveIngressLockerCharts, failedReceiveIngressSiteCharts, failedReceiveLockerPowerConsumptionChart, failedReceivePowerConsumptionChart, failedReceivePressureChart, failedReceiveRackPressureChart, failedReceiveRackTemperatureChart, failedReceiveTemperatureChart, receiveAirflowChart, receiveEgressInterfaceChart, receiveEgressLockerCharts, receiveEgressSiteCharts, receiveHumidityChart, receiveIngressInterfaceChart, receiveIngressLockerCharts, receiveIngressSiteCharts, receiveLockerPowerConsumptionChart, receivePowerConsumptionChart, receivePressureChart, receiveRackPressureChart, receiveRackTemperatureChart, receiveTemperatureChart } from './slice';
export function* requestAirflowChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getAirflowChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveAirflowChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const airflowChartCalculatedData = calculateChartFromChartData(chartData);
            const airflowChart = Object.assign(Object.assign({}, airflowChartCalculatedData), { title: t('AIRFLOW', {
                    ns: 'Common'
                }) });
            yield put(receiveAirflowChart(airflowChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveAirflowChart());
    }
}
export function* requestEgressInterfaceChart(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEgressInterfaceChart, chartOptions, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveEgressInterfaceChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const egressInterfaceCalculatedData = calculateChartFromChartData(chartData);
            const egressInterfaceChart = Object.assign(Object.assign({}, egressInterfaceCalculatedData), { title: t('EGRESS', {
                    ns: 'Common'
                }) });
            yield put(receiveEgressInterfaceChart(egressInterfaceChart));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveEgressInterfaceChart());
    }
}
export function* requestEgressLockerCharts(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEgressLockerCharts, chartOptions, organization);
        const { data: chartsDictionaryData, error } = response;
        if (error) {
            yield put(errorReceiveEgressLockerCharts());
        }
        else if (chartsDictionaryData) {
            const title = 'Egress';
            const egressLockerCharts = calculateSiteChartsFromChartsDictionaryData(chartsDictionaryData, title);
            if (!egressLockerCharts) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            yield put(receiveEgressLockerCharts(egressLockerCharts));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveEgressLockerCharts());
    }
}
export function* requestEgressSiteCharts(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEgressSiteCharts, chartOptions, organization);
        const { data: chartsDictionaryData, error } = response;
        if (error) {
            yield put(errorReceiveEgressSiteCharts());
        }
        else if (chartsDictionaryData) {
            const title = 'Egress';
            const egressSiteCharts = calculateSiteChartsFromChartsDictionaryData(chartsDictionaryData, title);
            if (!egressSiteCharts) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            yield put(receiveEgressSiteCharts(egressSiteCharts));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveEgressSiteCharts());
    }
}
export function* requestHumidityChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getHumidityChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveHumidityChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const humidityChartCalculatedData = calculateChartFromChartData(chartData);
            const humidityChart = Object.assign(Object.assign({}, humidityChartCalculatedData), { title: t('HUMIDITY', {
                    ns: 'Common'
                }) });
            yield put(receiveHumidityChart(humidityChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveHumidityChart());
    }
}
export function* requestIngressInterfaceChart(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getIngressInterfaceChart, chartOptions, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveIngressInterfaceChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const ingressInterfaceCalculatedData = calculateChartFromChartData(chartData);
            const ingressInterfaceChart = Object.assign(Object.assign({}, ingressInterfaceCalculatedData), { title: t('INGRESS', {
                    ns: 'Common'
                }) });
            yield put(receiveIngressInterfaceChart(ingressInterfaceChart));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveIngressInterfaceChart());
    }
}
export function* requestIngressLockerCharts(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getIngressLockerCharts, chartOptions, organization);
        const { data: chartsDictionaryData, error } = response;
        if (error) {
            yield put(errorReceiveIngressLockerCharts());
        }
        else if (chartsDictionaryData) {
            const title = 'Ingress';
            const ingressLockerCharts = calculateSiteChartsFromChartsDictionaryData(chartsDictionaryData, title);
            if (!ingressLockerCharts) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            yield put(receiveIngressLockerCharts(ingressLockerCharts));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveIngressLockerCharts());
    }
}
export function* requestIngressSiteCharts(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getIngressSiteCharts, chartOptions, organization);
        const { data: chartsDictionaryData, error } = response;
        if (error) {
            yield put(errorReceiveIngressSiteCharts());
        }
        else if (chartsDictionaryData) {
            const title = 'Ingress';
            const ingressSiteCharts = calculateSiteChartsFromChartsDictionaryData(chartsDictionaryData, title);
            if (!ingressSiteCharts) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            yield put(receiveIngressSiteCharts(ingressSiteCharts));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveIngressSiteCharts());
    }
}
export function* requestLockerPowerConsumptionChart(action) {
    try {
        const { chartOptions } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getPowerConsumptionChart, chartOptions, organization);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveLockerPowerConsumptionChart());
        }
        else if (data === null || data === void 0 ? void 0 : data.series) {
            const { series } = data;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const lockerPowerConsumptionChartCalculatedData = calculateChartFromChartData(data);
            const lockerPowerConsumptionChart = Object.assign(Object.assign({}, lockerPowerConsumptionChartCalculatedData), { title: t('LOCKER_POWER_CONSUMPTION', {
                    ns: 'Common'
                }) });
            yield put(receiveLockerPowerConsumptionChart(lockerPowerConsumptionChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveLockerPowerConsumptionChart());
    }
}
export function* requestPowerConsumptionChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getPowerConsumptionChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceivePowerConsumptionChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const powerConsumptionChartCalculatedData = calculateChartFromChartData(chartData);
            const powerConsumptionChart = Object.assign(Object.assign({}, powerConsumptionChartCalculatedData), { title: t('POWER_CONSUMPTION', {
                    ns: 'Common'
                }) });
            yield put(receivePowerConsumptionChart(powerConsumptionChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceivePowerConsumptionChart());
    }
}
export function* requestPressureChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getPressureChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceivePressureChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const pressureChartCalculatedData = calculateChartFromChartData(chartData);
            const pressureChart = Object.assign(Object.assign({}, pressureChartCalculatedData), { title: t('PRESSURE', {
                    ns: 'Common'
                }) });
            yield put(receivePressureChart(pressureChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceivePressureChart());
    }
}
export function* requestRackPressureChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getPressureChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveRackPressureChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const rackPressureChartData = calculateChartFromChartData(chartData);
            const rackPressureChart = Object.assign(Object.assign({}, rackPressureChartData), { title: t('RACK_PRESSURE', {
                    ns: 'Common'
                }) });
            yield put(receiveRackPressureChart(rackPressureChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveRackPressureChart());
    }
}
export function* requestRackTemperatureChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getTemperatureChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveRackTemperatureChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const rackTemperatureChartCalculatedData = calculateChartFromChartData(chartData);
            const rackTemperatureChart = Object.assign(Object.assign({}, rackTemperatureChartCalculatedData), { title: t('RACK_TEMPERATURE', {
                    ns: 'Common'
                }) });
            yield put(receiveRackTemperatureChart(rackTemperatureChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveRackTemperatureChart());
    }
}
export function* requestTemperatureChart(action) {
    try {
        const { chartOptions } = action.payload;
        const response = yield call(getTemperatureChart, chartOptions);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveTemperatureChart());
        }
        else if (data && data.length > 0) {
            const chartData = data[0];
            const { series } = chartData;
            if (!series || series.length < 1) {
                throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const temperatureCalculatedData = calculateChartFromChartData(chartData);
            const temperatureChart = Object.assign(Object.assign({}, temperatureCalculatedData), { title: t('TEMPERATURE', {
                    ns: 'Common'
                }) });
            yield put(receiveTemperatureChart(temperatureChart));
        }
        else {
            throw new Error(t('NO_CHART_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveTemperatureChart());
    }
}
export function* watchRequestAirflowChart() {
    yield takeLatest('charts/requestAirflowChart', requestAirflowChart);
}
export function* watchRequestEgressInterfaceChart() {
    yield takeLatest('charts/requestEgressInterfaceChart', requestEgressInterfaceChart);
}
export function* watchRequestEgressLockerCharts() {
    yield takeLatest('charts/requestEgressLockerCharts', requestEgressLockerCharts);
}
export function* watchRequestEgressSiteCharts() {
    yield takeLatest('charts/requestEgressSiteCharts', requestEgressSiteCharts);
}
export function* watchRequestHumidityChart() {
    yield takeLatest('charts/requestHumidityChart', requestHumidityChart);
}
export function* watchRequestIngressInterfaceChart() {
    yield takeLatest('charts/requestIngressInterfaceChart', requestIngressInterfaceChart);
}
export function* watchRequestIngressLockerCharts() {
    yield takeLatest('charts/requestIngressLockerCharts', requestIngressLockerCharts);
}
export function* watchRequestIngressSiteCharts() {
    yield takeLatest('charts/requestIngressSiteCharts', requestIngressSiteCharts);
}
export function* watchRequestLockerPowerConsumptionChart() {
    yield takeLatest('charts/requestLockerPowerConsumptionChart', requestLockerPowerConsumptionChart);
}
export function* watchRequestPowerConsumptionChart() {
    yield takeLatest('charts/requestPowerConsumptionChart', requestPowerConsumptionChart);
}
export function* watchRequestPressureChart() {
    yield takeLatest('charts/requestPressureChart', requestPressureChart);
}
export function* watchRequestRackPressureChart() {
    yield takeLatest('charts/requestRackPressureChart', requestRackPressureChart);
}
export function* watchRequestRackTemperatureChart() {
    yield takeLatest('charts/requestRackTemperatureChart', requestRackTemperatureChart);
}
export function* watchRequestTemperatureChart() {
    yield takeLatest('charts/requestTemperatureChart', requestTemperatureChart);
}
